<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <footer class="the-footer flex-wrap justify-between" :class="classes">
    <span>
      COPYRIGHT @ 2021
      <a href="https://www.jaklingkoindonesia.co.id/id" target="_blank" rel="nofollow">JAKLINGKO</a>, All rights Reserved
    </span>
    <span class="md:flex hidden items-center">
      <span>Hand-crafted & Made with</span>
      <feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2 mr-2" />
      <span> from Aino</span>
    </span>
    <vs-button  type="gradient" class="support" @click="toSupport" icon-pack="feather" icon="icon-phone-call">
      Help & Support
    </vs-button>
  </footer>
</template>

<script>
export default {
  name: "the-footer",
  props: {
    classes: {
      type: String
    }
  },
  methods:{
    toSupport(){
      window.open(process.env.VUE_APP_LINK_SUPPORT, '_blank')
    }
  }
};
</script>
<style>
  .support {
    position: fixed;
    bottom: 5%;
    z-index: 51000;
    right: 79px;
  }
</style>
